import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, FacebookAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBaRTEtsnczGDR2_ICNR2D_6ZpKOmwrKgQ",
  authDomain: "mahjspace-5e540.firebaseapp.com",
  projectId: "mahjspace-5e540",
  storageBucket: "mahjspace-5e540.firebasestorage.app",
  messagingSenderId: "949973264397",
  appId: "1:949973264397:web:a283d7e23b2237fc8c8d44"
};
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, "us-central1");
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();
export const facebookProvider = new FacebookAuthProvider();
